/* ANTI Labs — Route cart-widget tailor (2026-08-19, Remy's True Classic cart
   direction). VENDOR-DOM ADJACENT: Route mounts its preferred-checkout UI into
   the cart drawer at runtime; this file re-dresses that UI as a receipt row and
   relabels its button, per the approved cart design.

   RULES OF ENGAGEMENT (same posture as component-cart-drawer.css's Route
   block): text, visibility, and ONE positional move — the (i) dialog trigger
   relocates beside the coverage label via appendChild, which preserves its
   listeners (Remy 2026-08-19 round 2: "put it next to free returns... so the
   price can still be right aligned"). No handler changes, no removal of
   anything interactive. Every step is feature-detected and
   idempotent; if Route ships new class names, every selector misses and the
   customer gets Route's stock UI, which always works. Re-applies via a
   document-level MutationObserver because the drawer body is innerHTML-swapped
   on every cart change (inline scripts do not re-execute there) and Route
   itself re-mounts asynchronously.

   What it does when the hooks exist:
   · "Checkout" on Route's protected button reads "Protected Checkout"
     (was "Secure Checkout" until 2026-08-19 round 4).
   · The "+$X.XX Free Returns and Package Protection" subline comes off the
     button; the fee it carried moves to the coverage strip's right side, so
     protection reads as a receipt line item (True Classic pattern).
   · The strip's text reads "Package Protection & Free Returns"; Route's (i)
     keeps opening Route's own benefits dialog untouched. (The "Included in
     Protected Checkout" subline was CUT 2026-08-19 — Remy: it crowded the row.)
   · Route's protected button is tagged data-cc-route-btn (so CSS can dress it
     as the canonical CTA) and gains the padlock the Liquid button carries;
     the "Checkout Without Package Protection" link is tagged
     data-cc-route-alt for the lighter type shade. Additive + idempotent,
     like the fee move.
   · The Liquid-rendered .cc-cart__foot-row--protect (fed by a Route CART
     ITEM, the post-opt-in state) hides while Route's strip is present, so
     protection is never itemized twice. */
(function () {
  'use strict';
  var FEE_RE = /\+\s*(\$[\d,.]+)/;

  function tailor() {
    /* PERF BAIL (2026-08-19 load audit): this runs on every document mutation
       via the observer below — timers and app widgets mutate the DOM about
       once a second, so on pages where Route has mounted NOTHING (most
       pageviews) every pass below was pure waste, including a full-document
       button/a/span scan. One selector probe and out. */
    if (!document.querySelector('[class*="pw-cashback"], span.route-button-text, span.route-checkout-text-stacked')) return;

    // 1. Button label + canonical-CTA dressing. The label swap is text-only;
    //    the tag lets component-cart-drawer.css restyle the button as the
    //    standard .cc-btn-primary object, and the padlock matches the Liquid
    //    checkout button's (same path data). Both additive and idempotent.
    ['route-button-text', 'route-checkout-text-stacked'].forEach(function (cls) {
      document.querySelectorAll('span.' + cls).forEach(function (el) {
        var t = el.textContent.trim();
        if (t === 'Checkout' || t === 'Secure Checkout') el.textContent = 'Protected Checkout';
        var btn = el.closest('button, [role="button"], a');
        if (btn) {
          btn.setAttribute('data-cc-route-btn', '');
          if (!btn.querySelector('[data-cc-route-lock]')) {
            var lock = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            lock.setAttribute('data-cc-route-lock', '');
            lock.setAttribute('viewBox', '0 0 24 24');
            lock.setAttribute('width', '14');
            lock.setAttribute('height', '14');
            lock.setAttribute('fill', 'none');
            lock.setAttribute('stroke', 'currentColor');
            lock.setAttribute('stroke-width', '1.7');
            lock.setAttribute('stroke-linecap', 'round');
            lock.setAttribute('stroke-linejoin', 'round');
            lock.setAttribute('aria-hidden', 'true');
            var r = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            r.setAttribute('x', '5'); r.setAttribute('y', '11');
            r.setAttribute('width', '14'); r.setAttribute('height', '9');
            r.setAttribute('rx', '1.5');
            var a = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            a.setAttribute('d', 'M8 11V8a4 4 0 0 1 8 0v3');
            lock.appendChild(r); lock.appendChild(a);
            el.insertBefore(lock, el.firstChild);
          }
        }
      });
    });

    // 1b. The uncovered-checkout link — tagged for the lighter type shade
    //     (Remy 2026-08-19: "one font shade lighter, still in our token
    //     system"). Matched on its text because Route's class names churn.
    document.querySelectorAll('[class*="route"] button, [class*="route"] a, [class*="route"] span, [class*="pw-"] button, [class*="pw-"] a, [class*="pw-"] span').forEach(function (el) {
      if (el.children.length === 0 && /^Checkout Without Package Protection$/i.test(el.textContent.trim())) {
        var alt = el.closest('button, a') || el;
        alt.setAttribute('data-cc-route-alt', '');
      }
    });

    // 2. Fee off the button, onto the strip. The span is created once but
    //    RE-SYNCED on every pass (2026-08-26, Remy's stale-fee bug): Route
    //    updates the hidden subline's text in place on quantity changes, and
    //    the old exists-guard skipped the copy — so the visible fee stuck at
    //    the previous quantity's value ($4.75 shown while Route said $7.15)
    //    whenever the strip survived the drawer swap instead of remounting.
    var premium = document.querySelector('.route-premium-text-stacked');
    var right = document.querySelector('.pw-cashback-header-row-right');
    if (premium) {
      var m = premium.textContent.match(FEE_RE);
      if (m && right) {
        var fee = right.querySelector('[data-cc-route-fee]');
        if (!fee) {
          fee = document.createElement('span');
          fee.setAttribute('data-cc-route-fee', '');
          fee.textContent = m[1];
          right.insertBefore(fee, right.firstChild);
        } else if (fee.textContent !== m[1]) {
          fee.textContent = m[1];
        }
      }
      // Hidden only once the fee has a home (or carries none to lose).
      if (!m || (right && right.querySelector('[data-cc-route-fee]'))) {
        premium.style.display = 'none';
      }
    }

    // 3. Strip text -> receipt line. Route's own copy is preserved in the (i)
    //    dialog; aria-label on the icon still announces the full context.
    //    (The "Included in Protected Checkout" subline injection was removed
    //    2026-08-19 — Remy's cart feedback; the cleanup below retires any
    //    instance an earlier version of this file already placed.)
    //    MATCHED BY CLASS since 2026-08-26: Route renamed the element's id
    //    (#pw-coverage-description -> #pw-coverage-description-collapsed),
    //    which silently killed this rename AND steps 3b/4/5 below — the stock
    //    long label then overflowed its cell into the fee at 375 (Remy's
    //    mobile-overlap bug). The class survived the rename; the old id stays
    //    as a fallback.
    var descs = document.querySelectorAll('.pw-coverage-description, #pw-coverage-description');
    descs.forEach(function (el) {
      if (el.getAttribute('data-cc-tailored') !== '1') {
        el.setAttribute('data-cc-tailored', '1');
        el.textContent = 'Package & Shipping Protection';
      }
    });
    var desc = descs[0] || null;
    document.querySelectorAll('[data-cc-route-sub]').forEach(function (el) { el.remove(); });

    // 3b. The (i) moves beside the label so the fee stands alone on the right
    //     (Remy 2026-08-19 round 2). appendChild preserves Route's listeners;
    //     data-cc-route-info lets the CSS shrink it to 11px. Candidates cover
    //     Route's tooltip class family; a miss leaves the stock position.
    var left = document.querySelector('.pw-cashback-header-row-left');
    if (left && desc) {
      var info = document.querySelector(
        '.pw-cashback-header-container [class*="tooltip" i]:not(.pw-cashback-tooltip-text), ' +
        '.pw-cashback-header-container [aria-haspopup], ' +
        '.pw-cashback-header-container [class*="info-icon" i]');
      if (info && info !== desc && !info.contains(desc) && !left.contains(info)) {
        info.setAttribute('data-cc-route-info', '');
        left.appendChild(info);
      }
    }

    // 3c. Route's logo comes off the benefits dialog (Remy 2026-08-19 round 2).
    //     Scoped to dialog/modal ancestors so no product imagery is touched.
    document.querySelectorAll('[role="dialog"] img, [class*="modal" i] img, [class*="drawer" i] [class*="pw-"] img').forEach(function (img) {
      var sig = (img.getAttribute('src') || '') + ' ' + (img.getAttribute('alt') || '') + ' ' + img.className;
      if (/route/i.test(sig)) img.style.display = 'none';
    });

    // 4. Never two protection lines: the Liquid row (Route cart-item state)
    //    yields to the live strip.
    var liquidRow = document.querySelector('.cc-cart__foot-row--protect');
    if (liquidRow) liquidRow.style.display = desc ? 'none' : '';

    // 5. Grey-wrapper sweep (Remy 2026-08-19 round 5: "remove the gray
    //    module... just text"). Route paints a background on some wrapper
    //    between the strip and our footer whose class name we cannot pin
    //    from the draft — walk up from the coverage label to the drawer
    //    footer and clear any painted background/border along the way.
    //    Inline-style only, visual only, idempotent.
    if (desc) {
      var node = desc.parentElement;
      var hops = 0;
      while (node && hops < 8 && !node.classList.contains('cc-cart__foot')) {
        var cs = window.getComputedStyle(node);
        if (cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && cs.backgroundColor !== 'transparent') {
          node.style.setProperty('background', 'transparent', 'important');
        }
        if (cs.borderTopWidth !== '0px' || cs.borderBottomWidth !== '0px') {
          node.style.setProperty('border', '0', 'important');
        }
        node.style.setProperty('box-shadow', 'none', 'important');
        // Round 6: the wrappers' own padding/margins knock the row off the
        // receipt's grid — flattened on every side (round 7 added vertical;
        // the container's own --space-2 margin-top is the one spacing source).
        node.style.setProperty('padding', '0', 'important');
        node.style.setProperty('margin', '0', 'important');
        // Receipt-rhythm normalisation (Aaron 2026-08-21, "make the spacing
        // even... same space between shipping and package protection"): the
        // flatten pass zeroed EVERY margin, so the strip sat flush against
        // whichever receipt row it landed near while the dl's own rows keep
        // their space-2 gap. The OUTERMOST wrapper — the node whose parent is
        // the receipt dl or the footer itself — takes exactly one space-2 top
        // margin back, and a flex `order` between Est. Delivery and Shipping
        // (dl rows are flex-ordered: protection 8, shipping 9).
        var par = node.parentElement;
        if (par && (par.classList.contains('cc-cart__foot') || par.classList.contains('cc-cart__foot-receipt'))) {
          if (par.classList.contains('cc-cart__foot-receipt')) {
            node.style.setProperty('order', '10', 'important');
            node.style.setProperty('margin', '0', 'important');
          } else {
            node.style.setProperty('margin', 'calc(var(--space-1, 4px) / 2) 0 0', 'important');
          }
        }
        node = node.parentElement;
        hops += 1;
      }
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    /* setTimeout, NOT requestAnimationFrame: rAF never fires in hidden or
       background tabs, so an add-to-cart made from one would sit untailored
       until the tab surfaced (found 2026-08-19 verifying in a hidden pane —
       the whole file ran clean and then the debounce starved). */
    setTimeout(function () { scheduled = false; tailor(); }, 16);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ── Route "Zippy" (<route-cart-preferred>) — 2026-09-24, Remy ─────────────────
   theme.liquid now asks Route for its current widget (Zippy) instead of the legacy
   bundle above. Zippy keeps OUR checkout button (it wraps it and writes a fee subline
   into it, hidden by component-cart-drawer.css) and draws its own card + opt-out link
   in an OPEN shadow root. This re-creates the legacy receipt exactly:
   · a "Package & Shipping Protection (i) $X" row appended to our receipt dl after
     Shipping, fed by Zippy's own total-amount attribute (re-synced on every quote);
   · the row's (i) clicks Zippy's (hidden) card header, so it opens Zippy's inline
     benefits list just as the legacy (i) opened Route's;
   · a small adopted sheet inside the shadow root puts that list in the legacy list's
     type and rhythm (tokens resolve there: custom properties cross the boundary);
   · the Liquid Route-cart-item row yields while the live row shows (never two lines).
   Same posture as the legacy block: visual only, never touches Route's handlers, and
   if Zippy is absent every step no-ops. */
(function () {
  'use strict';
  var INFO_PATH = 'M10 9.16667H10.8333V15H9.16667V10.8333C8.70667 10.8333 8.33333 10.46 8.33333 10C8.33333 9.54 8.70667 9.16667 9.16667 9.16667H10ZM10 20C4.4775 20 0 15.5225 0 10C0 4.4775 4.4775 0 10 0C15.5225 0 20 4.4775 20 10C20 15.5225 15.5225 20 10 20ZM10 18.3333C14.6025 18.3333 18.3333 14.6025 18.3333 10C18.3333 5.3975 14.6025 1.66667 10 1.66667C5.3975 1.66667 1.66667 5.3975 1.66667 10C1.66667 14.6025 5.3975 18.3333 10 18.3333ZM8.75 6.25C8.75 5.56 9.305 5 10 5C10.69 5 11.25 5.555 11.25 6.25C11.25 6.94 10.695 7.5 10 7.5C9.31 7.5 8.75 6.945 8.75 6.25Z';
  function money(amount, currency) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(Number(amount)); }
    catch (e) { return '$' + Number(amount).toFixed(2); }
  }
  /* Inside Zippy's (open) shadow root: its benefits list in the legacy list's rhythm. Custom
     properties inherit through the shadow boundary, so the brand tokens resolve here. */
  var SHADOW_CSS =
    '.route-cart__card-details--open{margin-top:var(--space-1);margin-bottom:calc(var(--space-4) + var(--space-2))}' +
    '.route-cart__card-details-body{padding:0}' +
    '.route-cart__benefits-body-header{margin:0}' +
    '.route-cart__benefits-title{color:color-mix(in srgb,var(--cc-black) 60%,transparent);letter-spacing:0.075em}' +
    '.route-cart__benefit-icon svg{width:11.5px;height:8.5px}' +
    '.route-cart__see-details-button{color:var(--cc-black)}' +
    '.route-cart__benefit-list,#route-benefits{gap:0;margin-top:0}' +
    '.route-cart__benefit{min-height:15px;align-items:center}' +
    '.route-cart__benefit-text{color:var(--cc-ink);line-height:1.125}';
  var sheet = null;
  function dressShadow(widget) {
    var root = widget.shadowRoot;
    if (!root || widget.__ccDressed || !('adoptedStyleSheets' in root)) return;
    try {
      if (!sheet) { sheet = new CSSStyleSheet(); sheet.replaceSync(SHADOW_CSS); }
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
      widget.__ccDressed = true;
    } catch (e) { widget.__ccDressed = true; }
  }
  function header(widget) { return widget.shadowRoot && widget.shadowRoot.querySelector('#route-card-header'); }
  function buildRow() {
    var row = document.createElement('div');
    row.className = 'cc-cart__foot-row cc-cart__foot-row--quiet cc-cart__foot-row--zippy';
    row.setAttribute('data-cc-zippy-row', '');
    row.innerHTML = '<dt class="cc-cart__foot-row-l cc-cart__foot-quiet-l cc-cart__foot-zippy-l"><span>Package &amp; Shipping Protection</span>' +
      '<button type="button" class="cc-cart__foot-zippy-info" data-cc-zippy-info aria-label="See what’s included" aria-expanded="false">' +
      '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="' + INFO_PATH + '" fill="currentColor"/></svg></button></dt>' +
      '<dd class="cc-cart__foot-row-r cc-cart__foot-row-r--calc cc-cart__foot-zippy-fee" data-cc-zippy-fee></dd>';
    row.querySelector('[data-cc-zippy-info]').addEventListener('click', function () {
      var widget = document.querySelector('.cc-cart__foot route-cart-preferred');
      var h = widget && header(widget);
      if (h) h.click();
    });
    return row;
  }
  function tailor() {
    var widget = document.querySelector('.cc-cart__foot route-cart-preferred');
    var row = document.querySelector('[data-cc-zippy-row]');
    var receipt = document.querySelector('.cc-cart__foot-receipt');
    var liquidRow = document.querySelector('.cc-cart__foot-row--protect');
    var amount = widget && widget.getAttribute('total-amount');
    if (!widget || !receipt || !amount) {
      if (row) row.remove();
      // only undo what THIS block hid — the legacy block above owns the row otherwise
      if (liquidRow && liquidRow.hasAttribute('data-cc-zippy-hid')) { liquidRow.style.display = ''; liquidRow.removeAttribute('data-cc-zippy-hid'); }
      return;
    }
    dressShadow(widget);
    if (!row || row.parentElement !== receipt) { if (row) row.remove(); row = buildRow(); receipt.appendChild(row); }
    var fee = row.querySelector('[data-cc-zippy-fee]');
    var text = money(amount, widget.getAttribute('currency-code'));
    if (fee.textContent !== text) fee.textContent = text;
    if (liquidRow) { liquidRow.style.display = 'none'; liquidRow.setAttribute('data-cc-zippy-hid', ''); }
    var h = header(widget), info = row.querySelector('[data-cc-zippy-info]');
    // Zippy sets the header's aria-expanded a tick after the click, inside its
    // shadow root where the document observer can't see; watch it directly.
    if (h && !h.__ccAria) { h.__ccAria = new MutationObserver(schedule); h.__ccAria.observe(h, { attributes: true, attributeFilter: ['aria-expanded'] }); }
    if (h && info) { var open = h.getAttribute('aria-expanded') === 'true' ? 'true' : 'false'; if (info.getAttribute('aria-expanded') !== open) info.setAttribute('aria-expanded', open); }
  }
  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; setTimeout(function () { scheduled = false; tailor(); }, 16); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  new MutationObserver(schedule).observe(document, { childList: true, subtree: true, attributes: true, attributeFilter: ['total-amount'] });
})();
